import React, { useState } from "react";
import "./TutorPayment.css";
import { Link } from "react-router-dom";


const TutorPayment = () => {
  const [active, setActive] = useState();
  return (
    <div className="bg-green-100 h-screen">
      <div className="w-full h-20 flex justify-start pl-5 items-center bg-gree-100 shadow-md">
        <h2 className="text-xl text600 text-start text-green-900 font-montserrat">
          Payment and Refunds Policy
        </h2>
      </div>

      <div className="px-5 py-10 ">
        <div className="flex flex-col gap-5">
          <div className="rounded-lg bg-white w-full py-6 px-5">
            <h1 className="text-2xl text600 font-montserrat text-green-900">Need Help?</h1>
            <p className="text-sm mt-2  font-montserrat text-green-900">Would you like to know the payment method?</p>
          </div>
          <div className="flex flex-col justify-start items-start w-full py-6 px-5 bg-white rounded-lg">
            <h1 className="text-lg text-green-900 font-montserrat text600 ">
              Payments
            </h1>
            <p className="text-sm text-green-600 font-montserrat mt-2 text-start">
              After finalizing a job to a tutor we ask for (55%-Home Tutoring;
              55%-Online Tutoring; 35%-Package Tutoring; 55%-Group Tutoring)
              advance of his/her first month's payment only once for each
              tuition job.
            </p>
            <Link to="/dashboardTwo/tutorSubPayment">
            <button className="mt-2 border border-green-900 text-green-900 hover:bg-green-900 hover:text-white duration-300 px-4 py-1 rounded-lg font-montserrat text-sm">Click Here</button>
            </Link>
            
          </div>
          <div className="flex flex-col justify-start items-start w-full py-6 px-5 bg-white rounded-lg">
            <h1 className="text-lg text-green-900 font-montserrat text600 ">
              Refunds
            </h1>
            <p className="text-sm text-green-600 font-montserrat mt-2 text-start">
            When a tutor pays the platform charge in advance and after that he/she loses the tuition job with a valid reason, then his/her payment will be refunded under our return policy.
            </p>
            <Link to="/dashboardTwo/tutorSubReqRefund">
            <button className="mt-2 border border-green-900 text-green-900 hover:bg-green-900 hover:text-white duration-300 px-4 py-1 rounded-lg font-montserrat text-sm" >Request a Refund</button>
            </Link>
            
          </div>
        </div>
        {/* <Link to="/dashboardTwo/TermsConditions#paymentRefunds">
    <h1 className='headingPayRef mt-4'>Payment and Refunds Policy</h1>
</Link> */}
{/* 
        {active === "FirstCard" && <TutorSubPayment title="1" />}
        {active === "SecondCard" && <RequestRefound title="2" />} */}
      </div>
    </div>
  );
};
export default TutorPayment;
